import React from "react";
import { APICall } from "../../api_helper";
import {
  NewNewFormComponent,
  NewNewFormComponentProps,
} from "../new_form/NewNewFormComponent";
import { Button } from "semantic-ui-react";
import { useMutationWrapper } from "../../helper";

export const NewFormPageComponent = (props: {
  props: NewFormPageComponentProps;
}) => {
  const [data, setData] = React.useState<any>(props.props.form.startingData);
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [mutation] = useMutationWrapper(
    props.props.button.apiCall.documentNode,
    (data) => {
      props.props.button.callback(data[props.props.button.apiCall.key]);
    },
    (error) => {
      setErrorMessage(error.message);
      return true; // return true to indicate that the error has been handled and should not be propagated further
    },
  );

  return (
    <>
      {errorMessage !== "" && (
        <div style={{ color: "red" }} id="error-message">
          {errorMessage}
        </div>
      )}
      <NewNewFormComponent
        props={props.props.form}
        data={data}
        setData={setData}
      />
      <Button
        primary
        onClick={() => {
          mutation({ variables: { ...props.props.form.getData(data) } });
        }}
        floated="right"
        disabled={!props.props.form.isFormCompleted(data)}
      >
        {props.props.button.label}
      </Button>
    </>
  );
};

export type NewFormPageComponentProps = {
  type: "form";
  form: NewNewFormComponentProps;
  button: {
    label: string;
    apiCall: APICall;
    callback: (data: any) => void;
  };
};
